module.exports = __webpack_public_path__ + "static/media/download_grey.359eda10.svg";